import { useContext } from "react";
import { AppContext } from "../App";

export default function LightModeLockedPopup() {
	const { setPopup } = useContext(AppContext);
	const plansRows = [
		{ label: "Gestionale di cassa", smart: true, pro: true },
		{ label: "Gestione macro-categorie", smart: false, pro: true },
		{ label: "Gestione categorie e prodotti", smart: true, pro: true },
		{ label: "Gestione ingredienti", smart: false, pro: true },
		{ label: "Gestione varianti e categorie varianti", smart: false, pro: true },
		{ label: "Gestione ruolo operativi", smart: false, pro: true },
		{ label: "Gestione tavoli", smart: false, pro: true },
		{ label: "Asporto e delivery", smart: false, pro: true },
		{ label: "Prenotazioni tavolo", smart: true, pro: true },
		{ label: "App cameriere", smart: false, pro: true },
		{ label: "Stock prodotto", smart: false, pro: true },
	];
	const renderMark = (enabled) => (
		<div className={enabled ? "mark yes" : "mark no"}>
			<span className="mark-icon" aria-hidden="true">
				{enabled ? (
					<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
						<path
							fill="currentColor"
							d="M13.78 3.72a.75.75 0 010 1.06l-6.2 6.2a.75.75 0 01-1.06 0L2.22 6.7a.75.75 0 111.06-1.06l3.77 3.77 5.67-5.69a.75.75 0 011.06 0z"
						/>
					</svg>
				) : (
					<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
						<path
							fill="currentColor"
							d="M3.72 3.72a.75.75 0 011.06 0L8 6.94l3.22-3.22a.75.75 0 111.06 1.06L9.06 8l3.22 3.22a.75.75 0 11-1.06 1.06L8 9.06l-3.22 3.22a.75.75 0 11-1.06-1.06L6.94 8 3.72 4.78a.75.75 0 010-1.06z"
						/>
					</svg>
				)}
			</span>
		</div>
	);

	return (
		<div className="lightmode-locked">
			<button
				className="lightmode-locked-close"
				onClick={() => setPopup(false)}
				aria-label="Chiudi popup"
			>
				&times;
			</button>
			<div className="lightmode-locked-icon" aria-hidden="true">
				<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
					<path
						fill="currentColor"
						d="M8 1a3 3 0 00-3 3v2H4a1 1 0 00-1 1v7a1 1 0 001 1h8a1 1 0 001-1V7a1 1 0 00-1-1h-1V4a3 3 0 00-3-3zM6.5 4a1.5 1.5 0 013 0v2h-3V4z"
					/>
				</svg>
			</div>
			<div className="lightmode-locked-title">FUNZIONALITA PREMIUM</div>
			<div className="lightmode-locked-subtitle">
				Disponibile solo con <strong>Cassa PRO</strong>.
			</div>
			<div className="lightmode-locked-text">
				Scrivi a{" "}
				<strong>
					<a href="mailto:info@yellgo.it">info@yellgo.it</a>
				</strong>{" "}
				per avere tutte le informazioni oppure{" "}
				<strong>contatta il tuo referente commerciale</strong>.
			</div>
			<div className="lightmode-plan-compare">
				<div className="lightmode-plan-head lightmode-plan-grid">
					<div className="feature">Confronta i piani</div>
					<div className="plan">Smart</div>
					<div className="plan">Pro</div>
				</div>
				{plansRows.map((row, i) => (
					<div key={i} className="lightmode-plan-row lightmode-plan-grid">
						<div className="feature">{row.label}</div>
						{renderMark(row.smart)}
						{renderMark(row.pro)}
					</div>
				))}
			</div>
			<a
				className="lightmode-upgrade-cta"
				href="mailto:info@yellgo.it?subject=Richiesta%20Upgrade"
			>
				PASSA ALLA VERSIONE PRO
			</a>
		</div>
	);
}
